import React from 'react'
import PropTypes from 'prop-types'

import './style.css.scss'

const SubCategorySelector = (props) => {
  const {
    selectedSubCategoryId, categories, subcategoryIds, onClick, themeColorHex
  } = props

  return (
    <nav>
      <ul className="sub-categories">
        { subcategoryIds.map((subcategoryId, index) => {
          const isSelected = subcategoryId == selectedSubCategoryId
          return (
            <li
              key={index}
              className="sub-category"
              onClick={() => onClick(subcategoryId)}>
              {categories[subcategoryId].name}
              { isSelected && (
                <span className="selected" style={{ backgroundColor: themeColorHex }} />
              )}
            </li>
          )
        })}
      </ul>
    </nav>
  )
}

SubCategorySelector.propTypes = {
  categories: PropTypes.object.isRequired,
  subcategoryIds: PropTypes.array,
  selectedSubCategoryId: PropTypes.number.isRequired,
  onClick: PropTypes.func,
  themeColorHex: PropTypes.string
}

export default SubCategorySelector
